export default "* Koncentration\n* Samarbejde\n* Venskab";